import { ClubHttpHelper, NO_DATA_MESSAGE, BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

const postClubNationalPracticeData = (nationalPracticeData, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    let newState = {
      ...state,
      isSaving: true,
      isSaved: false,
      message: 'Saving...'
    };
    setState(newState);

    //const orgGroupIdForUrl = orgGroupId ? encodeURIComponent(orgGroupId) : '';
    const url = `/UsasClub/nationalPracticeData`;
    ClubHttpHelper(url, 'POST', nationalPracticeData)
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isSaving: false,
            isSaved: true,
            objData,
            message: ''
          };
          setState(newState);
        }

      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

const ClubNationalPracticeDataData = { INITIAL_STATE: BASIC_INITIAL_STATE, postClubNationalPracticeData };

export default ClubNationalPracticeDataData;

